import { render, staticRenderFns } from "./EditDialog.vue?vue&type=template&id=0afe96b6&scoped=true&"
import script from "./EditDialog.vue?vue&type=script&lang=ts&"
export * from "./EditDialog.vue?vue&type=script&lang=ts&"
import style0 from "./EditDialog.vue?vue&type=style&index=0&id=0afe96b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afe96b6",
  null
  
)

export default component.exports